import { render, staticRenderFns } from "./PoolEffect.vue?vue&type=template&id=3349a980&scoped=true&"
import script from "./PoolEffect.vue?vue&type=script&lang=js&"
export * from "./PoolEffect.vue?vue&type=script&lang=js&"
import style0 from "./PoolEffect.vue?vue&type=style&index=0&id=3349a980&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3349a980",
  null
  
)

export default component.exports